const CubeTick = ({ color = 'var(--Icon-strong-06)', style = {}, size = '13' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M12.6185 7.81119V5.00775C12.6181 4.79081 12.5604 4.57782 12.4512 4.39035C12.342 4.20288 12.1853 4.0476 11.9967 3.94022L7.64455 1.44827C7.45519 1.3401 7.24089 1.2832 7.02281 1.2832C6.80473 1.2832 6.59042 1.3401 6.40106 1.44827L2.04887 3.9396C1.66401 4.16032 1.42712 4.56756 1.42712 5.00775V9.99288C1.42712 10.4337 1.66401 10.8403 2.04887 11.0604L6.40106 13.5524C6.59042 13.6605 6.80473 13.7174 7.02281 13.7174C7.24089 13.7174 7.45519 13.6605 7.64455 13.5524"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path d="M7.02222 13.7174V7.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M7.02222 7.50077L12.45 4.36719"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M1.59375 4.36719L7.02156 7.50077"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M9.37439 11.8529C9.89509 12.3736 10.7077 13.1862 10.7077 13.1862L13.3744 10.5195"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default CubeTick
